import {useEffect,useState} from 'react';
import Contact from './components/Contact';
import Hero from './components/Hero';
import Projects from './components/Projects';
import {portfolioSettings,projects as fallbackProjects} from './content/portfolioContent';
import {fetchPortfolioSettings,fetchProjects} from './services/wordpressApi';
import './App.css';

function App() {
  const [settings,setSettings]=useState(portfolioSettings);
  const [projects,setProjects]=useState(fallbackProjects);

  useEffect(()=> {
    let isMounted=true;

    fetchPortfolioSettings(portfolioSettings)
      .then((wordpressSettings)=> {
        if (isMounted) {
          setSettings(wordpressSettings);
        }
      })
      .catch((error)=> {
        console.warn(
          'WordPress Portfolio Settings unavailable. Using fallback content.',
          error
        );
      });

    fetchProjects(fallbackProjects)
      .then((wordpressProjects)=> {
        if (isMounted) {
          setProjects(wordpressProjects);
        }
      })
      .catch((error)=> {
        console.warn(
          'WordPress Projects unavailable. Using fallback content.',
          error
        );
      });

    return ()=> {
      isMounted=false;
    };
  },[]);

  return (
    <main>
      <Hero content={settings} />
      <Projects projects={projects} />
      <Contact content={settings} />
    </main>
  );
}

export default App;